import React, { Component } from "react";
import { Button, Modal } from "antd";
import { observer } from "mobx-react";
import { Web3Store } from "../../stores/web3Store";
import { MythModal } from "../mythModal/mythModal";
import { MythModalMobile } from "../mythModal";
import { LazyLoader } from "../lazyLoader";
import img3 from "../../images/step-img3.webp";
import img4 from "../../images/step-img4.webp";
import { LeftCircleOutlined, RightCircleOutlined } from "@ant-design/icons";
import { Swiper, SwiperSlide } from "swiper/react/swiper-react";
import { Grid, Navigation } from "swiper";
import MythImage from "../MythImage";
import "swiper/swiper.less";
import "swiper/modules/grid/grid.less";
import "./index.less"
import { getMythPassRarity, MythPassRarity } from "../../constant/MythRarity";
import { IAction, IServerMythPass } from "../../bean/ResponseBean";
import { MythServerResultCode } from "../../constant/CommonConstant";
import logger from "../../logger";
interface IProps {
    web3Store: Web3Store,
    visible: boolean,
    onCancel: (reload: boolean) => void,
    passList: IServerMythPass[],//用户所有的pass
    actionJoinedPass: number[],//申请该活动打新的pass
    activeMenu: IAction,
}
interface IStates {
    selectedPASS: number,
    confirmLoading:boolean,
    confirmAvailable:boolean,
}

@observer
class RegisterWithMythPASS extends Component<IProps, IStates> {
    constructor(props: IProps, state: IStates) {
        super(props);
        this.state = {
            selectedPASS:-1,
            confirmLoading:false,
            confirmAvailable:!props.passList.length?true:false,
        };
    }
    onCancel = () => {
        const { onCancel } = this.props
        onCancel(false);
    }
    renderPassItem = (item: IServerMythPass) => {
        const { selectedPASS } = this.state
        //const selectedIndex = this.checkItemSelected(Number(item.id));
        const selected = selectedPASS === Number(item.id);

        return <SwiperSlide key={"pass-" + item.id + Math.random()} onClick={() => this.selectItem(Number(item.id))}>
            <div className="mint-pass-item">
                <div className={`image-box ${selected ? "selected" : ""}`}>
                    <MythImage src={getMythPassRarity(Number(item.id)) === MythPassRarity.GOLDEN ? img4 : img3} className="pass-image" />
                </div>
                <div className="text-center pass-name">MythPASS#{Number(item.id)}</div>
            </div>
        </SwiperSlide>
    }
    selectItem = (tokenId: number) => {
        const { selectedPASS,confirmLoading } = this.state;
        if(confirmLoading){
            return;
        }
        if(selectedPASS<0){
            this.setState({ selectedPASS: tokenId ,confirmAvailable:true});
        }else if(selectedPASS === tokenId){
            this.setState({ selectedPASS: -1 ,confirmAvailable:false});
        }else{
            this.setState({ selectedPASS: tokenId ,confirmAvailable:true});
        }

    }
    renderContent = () => {
        const { passList } = this.props;
        const { confirmAvailable,confirmLoading } = this.state;
        const showNavigation = passList.length > 10 ? "block" : "none";
        const attention = [
            "MythPASS is valid permanently and will not be consumed. But when you register, the PASS will be locked.",
            "Each PASS can only be used in one campaign at a time.",
            "Locked PASSes will not appear in this list."
        ]
        return <><div className="text-center mint-title">Register with a Myth PASS</div>
            {passList.length > 0 ? <div className="mint-pass-container">
                <Swiper
                    spaceBetween={20}
                    slidesPerView={5}
                    slidesPerGroup={5}
                    grid={{
                        fill: 'row',
                        rows: 2
                    }}
                    navigation={{
                        nextEl: ".swiper-next-nft",
                        prevEl: ".swiper-prev-nft",
                        disabledClass: "disabled"
                    }}
                    modules={[Grid, Navigation]}
                    className="market-swiper"
                >
                    {passList.map((item: IServerMythPass, index: number) =>
                        this.renderPassItem(item)
                    )}
                </Swiper>
                <LeftCircleOutlined className="swiper-prev swiper-prev-nft"
                    style={{ display: showNavigation }} />
                <RightCircleOutlined className="swiper-next swiper-next-nft"
                    style={{ display: showNavigation }} />
            </div>
                : <div className="empty-tip text-center"><span>You don't have any Myth PASS</span></div>}
            <div className="list-title">Attention</div>
            <ol className="attention-content">
                {attention.map((item, i) => (
                    <li key={"a-" + i}>{item}</li>))}
            </ol>
            <div className="text-center"><Button className="myth-button" onClick={this.confirmMint} loading={confirmLoading} disabled={!confirmAvailable}>Confirm</Button></div>
        </>
    }
    confirmMint = ()=>{
        const {web3Store,activeMenu,onCancel,passList}=this.props
        const {selectedPASS}=this.state
        if (!passList.length) {
            onCancel(false);
            return;
        }
        try {
            if (web3Store && web3Store.account) {
                this.setState({
                    confirmLoading:true
                })
                web3Store.mythServerApi.joinMintNew(activeMenu.actionId, selectedPASS, web3Store.account).then(value1 => {
                    if (value1.resultCode === MythServerResultCode.SUCCESS) {
                        Modal.info({
                            title: '',
                            content: "Registered successfully",
                            onOk:close => {
                                onCancel(true);
                                close();
                            }
                        });
                    }else{
                        onCancel(false);
                    }
                    this.setState({
                        confirmLoading:false
                    })
                }).catch(reason => {
                    logger.error(reason)
                    Modal.error({
                        title: 'Error',
                        content: reason,
                        onOk:close => {
                            close();
                        }
                    });
                    onCancel(false);
                    this.setState({
                        confirmLoading:false
                    })
                })

            }
        } catch (e: any) {
            logger.error(e);
            Modal.error({
                title: 'Error',
                content: e,
                onOk:close => {
                    close();
                }
            });
            onCancel(false);
            this.setState({
                confirmLoading:false
            })
        }
    }
    render() {
        const { visible } = this.props;
        const desk = <MythModal width="800px" visible={visible}
            className="mint-modal" onCancel={this.onCancel}>
            {this.renderContent()}
        </MythModal>
        const mobile = <MythModalMobile visible={visible} title="Register with a Myth PASS" className="mint-modal mint-modal-mobile" onCancel={this.onCancel}>{this.renderContent()}</MythModalMobile>
        return <LazyLoader desktop={desk} mobile={mobile} />
    }
}

export default RegisterWithMythPASS;
